import { CircleLayerSpecification } from 'maplibre-gl';

import { getTailWindColors } from '@/utils/common';

import { AcresMapboxLayerIds, AcresMapboxSourceIds } from '..';

const { 'sold-land': compColors } = getTailWindColors();

export const courthouseColor = compColors.courthouse;
export const curatedColor = compColors.curated;
export const contributoryColor = compColors.contributory;
export const confidentialColor = compColors.private;

export const userCompsLayer: CircleLayerSpecification = {
  id: AcresMapboxLayerIds.USER_COMPS,
  layout: {
    visibility: 'visible',
  },
  paint: {
    'circle-color': [
      'case',
      [
        'boolean',
        ['==', ['get', 'visibility', ['get', 'sale']], 'courthouse'],
        false,
      ],
      courthouseColor,
      [
        'boolean',
        ['==', ['get', 'visibility', ['get', 'sale']], 'curated'], // This is getting `sale.visibility`
        false,
      ],
      curatedColor,
      [
        'boolean',
        ['==', ['get', 'visibility', ['get', 'sale']], 'contributed'],
        false,
      ],
      contributoryColor,
      [
        'boolean',
        ['==', ['get', 'visibility', ['get', 'sale']], 'confidential'],
        false,
      ],
      confidentialColor,
      '#3E3E3E',
    ],
    'circle-radius': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      12,
      8,
    ],

    'circle-stroke-color': '#FBFBFB',
    'circle-stroke-width': 2,
  },
  source: AcresMapboxSourceIds.USER_COMPS,
  type: 'circle',
};

export const courthouseCompsLayer: CircleLayerSpecification = {
  ...userCompsLayer,
  id: AcresMapboxLayerIds.COURTHOUSE_COMPS,
  source: AcresMapboxSourceIds.COURTHOUSE_COMPS,
};
